module.exports = __webpack_public_path__ + "48c88d7725a78013f79d4c7e0025b477.png";